'use client';

import dynamic from 'next/dynamic';
import { Suspense, useState, useEffect } from 'react';

const CartRecommendedProducts = dynamic(() => import('./CartRecommendedProducts'), {
  loading: () => <div className="h-96 bg-gray-100 animate-pulse"></div>,
});

interface LazyLoadedCartRecommendedProductsProps {
  shoppingCart: boolean;
  frameColorZ: string;
}

function CartRecommendedProductsLazyLoaded({ frameColorZ, shoppingCart }: LazyLoadedCartRecommendedProductsProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return <div className="h-96 bg-gray-100 animate-pulse"></div>;
  }

  return (
    <Suspense fallback={<div className="h-96 bg-gray-100 animate-pulse"></div>}>
      <CartRecommendedProducts frameColorZ={frameColorZ} shoppingCart={shoppingCart} />
    </Suspense>
  );
}

export default CartRecommendedProductsLazyLoaded;
